class BaoSizeSwitcher extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.isLoading = false

    this.handleClick = this.handleClick.bind(this)
    this.handlePopState = this.handlePopState.bind(this)

    this.els.link.elements.forEach((link) => {
      this.listeners.add(link, 'click', this.handleClick)
    })

    this.listeners.add(window, 'popstate', this.handlePopState)
  }

  /**
   * @param {MouseEvent} event
   *
   * @returns {Promise<void>}
   */
  async handleClick (event) {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      this.isLoading
    ) {
      return
    }

    const url = event.currentTarget.getAttribute('href')
    if (!url) return

    event.preventDefault()

    this.isLoading = true
    this.setAttribute('aria-busy', 'true')

    try {
      const response = await fetch(url)
      const html = window.BAO.sectionRenderer.convertToDOM(await response.text())

      const host = this.externalEls?.host
      const current = host?.element
      const next = host ? html.querySelector(host.selector) : null

      if (!current || !next) {
        window.location.assign(url)
        return
      }

      this.updatePage(url, html)
      this.swap(current, next)
    } catch (error) {
      window.location.assign(url)
    } finally {
      this.isLoading = false
      this.removeAttribute('aria-busy')
    }
  }

  /**
   * @returns {void}
   */
  handlePopState () {
    window.location.reload()
  }

  /**
   * @param {HTMLElement} current
   * @param {HTMLElement} next
   *
   * @returns {void}
   */
  swap (current, next) {
    if (typeof document.startViewTransition === 'function') {
      document.startViewTransition(() => current.replaceWith(next))
      return
    }

    current.replaceWith(next)
  }

  /**
   * @param {string} url
   * @param {Document} html
   *
   * @returns {void}
   */
  updatePage (url, html) {
    const title = html.querySelector('head title')
    if (title) document.title = title.textContent

    window.history.pushState({}, '', url)
    window.scrollTo({ top: 0 })
  }
}

if (!customElements.get('bao-size-switcher')) {
  customElements.define('bao-size-switcher', BaoSizeSwitcher)
}
